import { IconType } from 'react-icons';
import {
  FaListAlt,
  FaMobileAlt,
  FaReceipt,
  FaRegBuilding,
  FaBalanceScale,
  FaFileAlt,
} from 'react-icons/fa';

export type FAQItem = {
  title: string;
  body: string;
  href?: string;
  icon?: keyof typeof ICONS;
};

export const ICONS: Record<string, IconType> = {
  services: FaListAlt,
  mobilePay: FaMobileAlt,
  receipt: FaReceipt,
  building: FaRegBuilding,
  finance: FaBalanceScale,
  documents: FaFileAlt,
};

export const faqItems: FAQItem[] = [
  {
    title: 'What services can I do online?',
    body: '',
    href: '#',
    icon: 'services',
  },
  {
    title: 'How do I pay my county invoice?',
    body: '',
    href: '#',
    icon: 'mobilePay',
  },
  {
    title: 'Where do I get an invoice or receipt?',
    body: '',
    href: '#',
    icon: 'receipt',
  },
  {
    title: 'How do I register as a supplier/contractor?',
    body: '',
    href: '#',
    icon: 'building',
  },
  {
    title: 'What are the current county fees and charges?',
    body: '',
      href: '#',
    icon: 'finance',
  },
  {
    title: 'What documents are required for a construction permit?',
    body: '',
    href: '#',
    icon: 'documents',
  },
];
